// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__mqw6E"};